import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ErrorScreen from "../components/ErrorScreen";
import Head from "next/head";
// import Layout from "../components/layout";
// import ScrollButton from "../components/scroll_button";
// import { people } from "../constants/team";
// import styles from "../styles/team.module.scss";

export default function Team() {
	// const router = useRouter();
	// const { t } = useTranslation("common");

	return (
		<>
			<Head>
				<meta name="robots" content="noindex, nofollow" />
				<title>404 Error</title>
			</Head>
			<ErrorScreen />
		</>
	);

	// const team = people.map((person, i) => (
	//   <div key={i}>
	//     <Image src={person.img} alt={person.name} />
	//     <h6>{t(person.name)}</h6>
	//     <p>{t(person.occupation)}</p>
	//   </div>
	// ));

	// return (
	//   <Layout title={t('teamTitle')} lang={router.locale} route={router.route} isHeader isFooter>
	//     <ScrollButton scrollStepInPx='50' delayInMs='16.66'/>
	//     <section className={styles.team}>
	//       <h3>{t('team.our_team')}</h3>
	//       <div className={'flex ' + styles.people}>
	//         {team}
	//       </div>
	//     </section>
	//   </Layout>
	// );
}

export const getStaticProps = async ({ locale }) => ({
	props: {
		...(await serverSideTranslations(locale, ["common", "main"])),
	},
});
